<div class="align-v-center">
  <button class="btn primary inverted icon-angle-left"
          [disabled]="this.ngControl.control.value === startMonth"
          (click)="changeMonth(-1)"
  ></button>

  <button class="btn primary inverted icon-angle-right mr-10"
          (click)="changeMonth(1)"
          [disabled]="this.ngControl.control.value === endMonth"
  ></button>
  <mat-form-field class="compact no-error" [ngClass]="inputClass">
    <mat-select [formControl]="ngControl.control" placeholder="Select month">
      <mat-option [value]="6">July</mat-option>
      <mat-option [value]="7">August</mat-option>
      <mat-option [value]="8">September</mat-option>
      <mat-option [value]="9">October</mat-option>
      <mat-option [value]="10">November</mat-option>
      <mat-option [value]="11">December</mat-option>
      <mat-option [value]="0">January</mat-option>
      <mat-option [value]="1">February</mat-option>
      <mat-option [value]="2">March</mat-option>
      <mat-option [value]="3">April</mat-option>
      <mat-option [value]="4">May</mat-option>
      <mat-option [value]="5">June</mat-option>
    </mat-select>
  </mat-form-field>
</div>
